import React from "react";

import {DownloadOutlined, DownOutlined, MenuOutlined, UpOutlined} from "@ant-design/icons";
import {UploadCustomRecommendationsModal} from "./UploadCustomRecommendationsModal";
import {Button, Col, Descriptions, Dropdown, Menu, message, Row, Table, Tag} from "antd";
import {Statistic} from "antd/es";
import Search from "antd/es/input/Search";

import {labels} from "../helpers/Labels";
import api from "../../api";
import axios from "../../api";
import * as Auth from "../../AuthService";
import { Auth as DigatexAuth } from "@digatex/digatex-ui-lib";
import {downloadExcel} from "../../helpers";
import {projectCurrency, ROP_MIN_LABEL} from "../../properties";
import {FilterRepresentation} from "../exception-reporting/ExceptionReporting";
import {
	date_rangeOptions,
	date_range_extendedOptions,
	dateOptions,
	formatExtendedDateRangeValue,
	isExtendedDateRangeType,
	numberOptions,
	stringOptions,
} from "../helpers/AdvancedFIlter";
import {DataCard} from "../helpers/cards/Card";
import {MaterialBlock, ScenarioLink} from "../helpers/cards/MaterialBlock";
import {CustomTabs} from "../helpers/CustomTabs";
import {StandardTable} from "../helpers/TablePanel";
import {Archive, MaterialInfo, FieldsNaming} from "../../variants";
import {PageTitle} from "../helpers/PageTitle";

const getModeLabel = mode => {
	const all = [
		...numberOptions,
		...stringOptions,
		...date_rangeOptions,
		...date_range_extendedOptions,
		...dateOptions,
	];
	return all.find(o => o.value === mode)?.label || mode;
};

export class ScopePage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			scopeId: window.location.pathname.split("/")[4],
			projectId: window.location.pathname.split("/")[2],
			scopeInfo: {},
			itemInfo: {
				material: window.location.pathname.split("/")[4],
			},
			overview: {},
			page: 1,
			search: "",
			query: "",
			labels: {},
			expandedRowKeys: [],
			activeTab: "items",
			size: 10,
			inApproval: [],
			scenarios: [],
			total: 0,
			loading: false,
			scopeData: [],
			archived: new URLSearchParams(window.location.search).get("archived") === "true",
			plantInfoFields: [],
			isUploadCustomModalVisible: false,
		};
	}

	getScopeInfo = () => {
		// if (this.state.projectId && this.state.scopeId) {
		api.get(
		    `/projects/${this.state.projectId}/scope/${this.state.scopeId}?archived=${this.state.archived}`
		).then(json => {
			if (json.data) {
				this.setState({scopeInfo: json.data});
				if (Object.keys(json.data).includes("overview")) {
					this.setState({overview: json.data.overview});
				} else {
					this.getScopeOverview();
				}
			} else {
				message.error("Scope was already deleted!");
			}
		});
		// }
	};

	getScopeOverview = () => {
		if (this.state.projectId && this.state.scopeId) {
			api.get(
			    `/projects/${this.state.projectId}/scope/${this.state.scopeId}/overview?archived=${this.state.archived}`
			)
			.then(json =>
				this.setState({overview: json.data}),
			);
		}
	};

	getScenarios = () => {
		const pagination = {
			current: 1,
			size: 50,
		};
		const data = {
			pagination,
			_filters: {
				scope: [this.state.scopeId],
			},
		};

		if (this.state.projectId && this.state.scopeInfo) {
			api.post(
			    `/projects/${this.state.projectId}/iterations?archived=${this.state.archived}`,
			    data
			)
            .then(json => {
	            let allIterations = [...json.data.iterations];

                if (Archive.enabled) {
		            return api.post(
			            `/projects/${this.state.projectId}/iterations?archived=${!this.state.archived}`,
		                data
		            )
                    .then((json2) => {
            			allIterations = allIterations.concat(json2.data.iterations);

		            	return allIterations;
		            });
		        }
		        return allIterations;
            })
			.then((allIterations) => {
				this.setState({scenarios: allIterations});
			});
		}
	};

	getPrettyNumber = _number => {
		if (_number / 1000000 > 1) {
			return (
				<Statistic
					title={`Total Value ${projectCurrency}`}
					value={Math.round(_number / 10000) / 100}
					suffix={"m"}
				/>
			);
		} else if (_number / 1000 > 1) {
			return (
				<Statistic
					title={`Total Value ${projectCurrency}`}
					value={Math.round(_number / 10) / 100}
					suffix={"K"}
				/>
			);
		}
	};

	getScopeItems = (page = this.state.page, size = this.state.size, query = this.state.query) => {
		if (!this.state.projectId || !this.state.scopeId) {
			return;
		}

		this.setState({loading: true});
		if ((size && size !== this.state.size) || this.state.query !== query) {
			page = 1;
		}
		api.get(
			`/projects/${this.state.projectId}/scope/${this.state.scopeId}/list?page=${page || this.state.page}&size=${size || this.state.size}&search=${query}
			&archived=${this.state.archived}`,
		)
			.then(json => {
				for (const item of json.data.items) {
					item.key = item.material;
				}

				this.setState({scopeData: json.data.items, total: json.data.total});
				if (page) {
					this.setState({page: page});
				}
				if (size) {
					this.setState({size});
				}
				if (query) {
					this.setState({query});
				}
			})
			.finally(() => this.setState({loading: false}));
	};

	getLabels = () => {
		api.get(`/projects/${this.state.projectId}/materials/attributes`).then(json => {
			const attributes = json.data;
			const mapping = {};
			for (const attr of attributes) {
				mapping[attr.field] = attr.label;
			}
			this.setState({labels: mapping});
		});
	};

	componentDidMount() {
		this.getScopeInfo();
		this.getScopeItems();
		this.getScenarios();
		this.getLabels();
		api.get(`/projects/${this.state.projectId}/materials/plant-info/fields`)
			.then(json => this.setState({plantInfoFields: json.data || []}));
	}

	renderPlantInfoFilterTag = filter => {
		const fieldLabel =
			this.state.plantInfoFields.find(f => f.field === filter.field)?.label || filter.field;
		const modeLabel = getModeLabel(filter.mode);
		const plantPart = filter.plant ? `Plant: ${filter.plant} - ` : "";
		if (filter.compare_with === "attribute") {
			return `${plantPart}${fieldLabel} ${modeLabel} ${filter.value?.label || filter.value?.key}`;
		}
		const value = isExtendedDateRangeType(filter.field_type)
			? formatExtendedDateRangeValue(filter.value, filter.mode)
			: Array.isArray(filter.value)
				? filter.value.join(", ")
				: filter.value;
		return `[${modeLabel}] ${plantPart}${fieldLabel}: ${value}`;
	};

	exportScope = () => {
		const hide = message.loading("Preparing Scope for download...", 0, () => {});

		const config = Auth.createConfig();
		config["responseType"] = "blob";
		axios
			.get(
			    `/projects/${this.state.projectId}/scope/${this.state.scopeId}/export?archived=${this.state.archived}`,
			     config
			)
			.then(json => {
				downloadExcel(json.data, `Scope ${this.state.scopeInfo.name}.xlsx`);
			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => setTimeout(hide, 1));
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.scopeInfo !== this.state.scopeInfo) {
			this.getScenarios();
		}
	}

	noop = () => {};

	getHistoryColumns = () => [
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			width: "140px",
		},
		{
			title: "Action",
			dataIndex: "action",
			key: "action",
			width: "140px",
		},
		{
			title: "User",
			dataIndex: "user",
			key: "user",
			width: "200px",
		},
		{
			title: "Details",
			dataIndex: "details",
			key: "details",
			render: details => {
				if (!details) return "";

				if (details.type === "criteria") {
					return (
						<div>
							{details.new ? (
								this.getFilterRepresentation(details.new)
							) : (
								<span style={{color: "#999"}}>Filters cleared</span>
							)}
						</div>
					);
				}

				if (details.type === "text") {
					return (
						<div style={{display: "flex", flexDirection: "column", gap: "4px"}}>
							{details.old_name !== details.new_name && (
								<div>
									<strong>Name:</strong> {details.new_name}
								</div>
							)}

							{details.old_desc !== details.new_desc && (
								<div>
									<strong>Description:</strong>{" "}
									{details.new_desc || <span style={{color: "#ccc"}}>empty</span>}
								</div>
							)}
						</div>
					);
				}

				return JSON.stringify(details);
			},
		},
	];

	getColumns = () => [
		{
			title: "Material",
			dataIndex: "material",
			key: "name",
			width: "8%",
			render: material => <MaterialBlock material={material}>{material}</MaterialBlock>,
		},
		{
			title: FieldsNaming.material_type,
			dataIndex: "Type",
			key: "type",
			width: "8%",
		},
		{
			title: "Description",
			dataIndex: "description",
			key: "description",
			width: "50%",
		},
		{
			title: "Demand",
			dataIndex: "demand",
			key: "demand",
			render: demand => Math.round(demand * 100) / 100,
		},
		{
			title: FieldsNaming.lead_time,
			dataIndex: "lt_days",
			key: "lt_days",
		},
		{
			title: "Price",
			dataIndex: "price",
			key: "price",
		},
		{
			title: ROP_MIN_LABEL,
			dataIndex: "rop",
			key: "min",
		},
		{
			title: "MAX",
			dataIndex: "max",
			key: "max",
		},
		{
			title: (
				<Dropdown overlay={this.menuItems}>
					<MenuOutlined />
				</Dropdown>
			),
			dataIndex: "",
			key: "max",
			render: (text, record) => record.plant_info.length,
		},
	];

	menuItems = (
		<Menu>
			<Menu.Item onClick={() => this.handlePlantInfo(true)}>Expand all</Menu.Item>
			<Menu.Item onClick={() => this.handlePlantInfo(false)}>Collapse all</Menu.Item>
		</Menu>
	);

	handlePlantInfo(expand) {
		if (!expand) {
			this.setState({expandedRowKeys: []});
		} else {
			this.setState({expandedRowKeys: this.state.scopeData.map(row => row.material)});
		}
	}

	getInApprovalColumns = () => [
		{
			title: "Material",
			dataIndex: "material",
			key: "name",
			width: "8%",

			render: material => <MaterialBlock material={material}>{material}</MaterialBlock>,
		},
		{
			title: "Material Type",
			dataIndex: "type",
			key: "type",
			width: "8%",
		},
		{
			title: `Current ${ROP_MIN_LABEL}`,
			dataIndex: "min",
			key: "min",
		},
		{
			title: `Proposed ${ROP_MIN_LABEL}`,
			dataIndex: "new_min",
			key: "new_min",
		},
		{
			title: "Current MAX",
			dataIndex: "max",
			key: "max",
		},
		{
			title: "Proposed MAX",
			dataIndex: "new_max",
			key: "new_max",
		},
	];

	getScenarioColumns = () => [
		{
			title: "Scenario",
			dataIndex: "iteration_name",
			key: "name",
			width: "10%",
			render: (name, item) => <ScenarioLink name={name} id={item["_id"]} />,
		},
	];

	onPageChange = (newPagination, _filters, _sorter) => {
		this.getScopeItems(newPagination.current, newPagination.pageSize);
	};

	onSearch = search => {
		this.getScopeItems(this.state.page, this.state.size, search);
	};

	nestedColumns = () => [
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
		},
		{
			title: "MRP Type",
			dataIndex: "MRP Type",
			key: "plant",
		},
		{
			title: `Plant ${ROP_MIN_LABEL}`,
			dataIndex: "rop",
			key: "plant",
		},
		{
			title: "Plant MAX",
			dataIndex: "max",
			key: "plant",
		},
		{
			title: "Plant Stock",
			dataIndex: "plant_stock_level",
			key: "plant",
		},
		{
			title: "Plant price",
			dataIndex: "plant_price",
			key: "plant",
		},
		{
			title: FieldsNaming.plant_lead_time,
			dataIndex: "plant_lead_time",
			key: "plant",
		},
		{
			title: "Plant Installed",
			dataIndex: "quantity",
			key: "plant",
		},
	];

	onExpand = (expanded, record) => {
		if (expanded) {
			const array = this.state.expandedRowKeys;
			array.push(record.material);
			this.setState({expandedRowKeys: array});
		} else {
			let array = this.state.expandedRowKeys;
			array = array.filter(item => item !== record.material);
			this.setState({expandedRowKeys: array});
		}
	};

	getTabs = () => [
		{
			name: "Scope Items",
			key: "items",
			children: (
				<div>
					<div>
						<b>Material Number:</b>{" "}
						<Search
							allowClear
							style={{width: 200, marginBottom: 10}}
							value={this.state.search}
							onChange={event => this.setState({search: event.target.value})}
							onSearch={this.onSearch}
						/>
					</div>
					<StandardTable
						size={"small"}
						loading={this.state.loading}
						style={{width: "100%"}}
						total={this.state.total["table_total"]}
						currentPage={this.state.page}
						columns={this.getColumns()}
						scroll={450}
						tableProps={{
							expandIconColumnIndex: 8,
							expandable: {
								expandedRowKeys: this.state.expandedRowKeys,
								onExpand: this.onExpand,
								expandedRowRender: record => (
									<p
										style={{
											margin: 0,
										}}>
										<Table
											className="nested-table-allocation"
											bordered={true}
											pagination={false}
											dataSource={record.plant_info}
											columns={this.nestedColumns()}
										/>
									</p>
								),
								expandIcon: ({expanded, onExpand, record}) =>
									expanded ? (
										<UpOutlined onClick={e => onExpand(record, e)} />
									) : (
										<DownOutlined onClick={e => onExpand(record, e)} />
									),
								rowExpandable: record => record.material,
							},
						}}
						onChange={this.onPageChange}
						pageSize={this.state.size}
						data={this.state.scopeData}
					/>
				</div>
			),
		},
		{
			name: `Attached Scenarios (${this.state.scenarios.length})`,
			key: "test",
			children: (
				<StandardTable
					size={"small"}
					loading={this.state.loading}
					style={{width: "100%"}}
					columns={this.getScenarioColumns()}
					scroll={450}
					data={this.state.scenarios}
				/>
			),
		},
		{
			name: `Used filters`,
			key: "filters",
			children: <div>{this.getFilterRepresentation()}</div>,
		},
		{
			name: "History",
			key: "history",
			children: (
				<StandardTable
					size={"small"}
					data={this.state.scopeInfo.history || []}
					columns={this.getHistoryColumns()}
					scroll={450}
					style={{width: "100%"}}
				/>
			),
		},
	];

	getFilterRepresentation = (criteria = this.state.scopeInfo["criteria"]) => {
		const getTagColor = condition => {
			switch (condition) {
				case "and":
					return "purple";
				case "or":
					return "cyan";
				default:
					return "white";
			}
		};
		if (!criteria || !criteria["or"] || !Array.isArray(criteria["or"])) {
			return <div>No active filters</div>;
		} else {
			const blocks = [];
			for (const x of criteria["or"]) {
				if (Array.isArray(x)) {
					blocks.push(
						<Tag style={{padding: 10, display: "block"}}>
							<FilterRepresentation
								break={true}
								filters={x}
								labels={{...labels, ...this.state.labels}}
								deleteFilter={this.noop}
							/>
						</Tag>,
					);
				} else {
					for (const cond in x) {
						const regularFilters = x[cond].filter(f => f.type !== "plant_info");
						const plantInfoFilters = x[cond].filter(f => f.type === "plant_info");
						const title = x[cond].length > 1 ? <div>And</div> : <div />;

						if (x[cond] && x[cond].length > 0) {
							blocks.push(
								<Row style={{padding: 5}}>
									<Tag icon={title} color={getTagColor(cond)} style={{padding: 10}}>
										{regularFilters.length > 0 && (
											<FilterRepresentation
												breakLines={true}
												filters={regularFilters}
												labels={{...labels, ...this.state.labels}}
												deleteFilter={this.noop}
											/>
										)}
										{plantInfoFilters.map((f, i) => (
											<div key={i} style={{marginTop: regularFilters.length > 0 || i > 0 ? 4 : 0}}>
												<Tag color="geekblue">
													{this.renderPlantInfoFilterTag(f)}
												</Tag>
											</div>
										))}
									</Tag>
								</Row>,
							);
						}
					}
				}
			}

			return (
				<Tag style={{padding: 10}} color={"magenta"} icon={<div>Or</div>}>
					{blocks}
				</Tag>
			);
		}
	};

	render() {
    const tokenParsed = DigatexAuth.tokenParsed();
    const roles = tokenParsed?.resource_access?.["workbench-api"]?.roles || [];
    const canUpload = roles.includes("min-max-senior") || roles.includes("workbench-api-superadmin");
		return (
			<>
				<PageTitle title={this.state.scopeInfo.name} />
				<Row>
					<Col span={11}>
						<DataCard
							style={{margin: 5}}
							title={
                                <div className="text-center">
                                    {this.state.scopeInfo.name && (
                                        <DownloadOutlined
                                            style={{marginRight: 10, color: "#107E70"}}
                                            onClick={this.exportScope}
                                        />
                                    )}
                                    Scope <b>{this.state.scopeInfo.name}</b>
                                    {canUpload && !this.state.archived && (
                                        <Button
                                            type="primary"
                                            style={{marginLeft: 20}}
                                            onClick={() => this.setState({isUploadCustomModalVisible: true})}
                                        >
                                            Upload Custom Recommendations
                                        </Button>
                                    )}
                                </div>
                            }>
							<Row>
							    {this.state.archived && (
							    <Descriptions>
									    <Descriptions.Item
									        label={"Scope was archived by"}
									        labelStyle={{fontWeight: "bold", color: "red"}}>
										    <span style={{ color: "red" }}>{this.state.scopeInfo.last_change_by}</span>
									    </Descriptions.Item>
								</Descriptions>)}
								<Descriptions>
									<Descriptions.Item label={"Scope description"} labelStyle={{fontWeight: "bold"}}>
										{this.state.scopeInfo.description}
									</Descriptions.Item>
								</Descriptions>
								<Col span={8}>
									<Statistic title={"Items"} value={this.state.total.with_plants} />
								</Col>
								<Col span={8}>
									<Statistic title={"Unique Items"} value={this.state.total.unique} />
								</Col>
								<Col span={8}>{this.getPrettyNumber(this.state.overview.value)}</Col>
							</Row>
						</DataCard>
					</Col>
				</Row>

				<DataCard style={{margin: 5}}>
					<CustomTabs
						activeKey={this.state.activeKey}
						defaultKey={this.state.activeKey}
						tabsData={this.getTabs()}
						onChange={activeKey => this.setState({activeKey: activeKey})}
					/>
				</DataCard>

				<UploadCustomRecommendationsModal
                    isModalVisible={this.state.isUploadCustomModalVisible}
                    setIsModalVisible={visible => this.setState({isUploadCustomModalVisible: visible})}
                    projectId={this.state.projectId}
                    scopeId={this.state.scopeId}
                />
			</>
		);
	}
}
